export default {
  namespaced: true,
  state: {
    loading: { isShow: false, value: '', isNum: false },
  },
  mutations: {
    start(state, loading) {
      state.loading = { ...loading, isShow: true };
    },
    stop(state) {
      state.loading = { isShow: false, isNum: false };
    },
    value(state, value) {
      state.loading = { value, isNum: true };
    },
  },
};
